module.exports = __webpack_public_path__ + "0dd4556aa71638d9ea9c4928ae5f6d77.jpg";


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/intro-bg.jpg
// module id = 303
// module chunks = 0